module.exports = __webpack_public_path__ + "villaFacil_ponto.png?e086a3c259fb946654eee0a41acaea8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/villaFacil_ponto.png
// module id = 815
// module chunks = 0